import { useIntl } from "react-intl";
import classNames from "classnames";
import moment from "moment";
import { BulkTest } from "@/model";
import { clickFromKeyboard } from "@/util/keyboardUtil";
import bulkTestRepository from "@/repository/bulkTestRepository";
import { useAgentId, useRouteHandler } from "@/hook";
import HighlightText from "@/component/HighlightText";
import { DownloadIcon } from "@/assets/svgs/icons";


interface BulkTestFragmentProps {
    bulkTest: BulkTest;
    statusLabel: string;
    searchKeyword?: string;
}

const BulkTestFragment: React.FC<BulkTestFragmentProps> = (props) => {
    const { bulkTest, statusLabel, searchKeyword } = props;

    const intl = useIntl();
    const agentId = useAgentId();

    const { moveToBulkTestResult } = useRouteHandler();

    const isComplete = bulkTest.status === "DONE";

    return (
        <div tabIndex={isComplete ? 0 : undefined}
             role="row"
             className={classNames(
                "selection-table-tr group",
                isComplete ? "cursor-pointer" : "no-hover"
            )}
             onClick={() => isComplete && moveToBulkTestResult(agentId, bulkTest.id)}
             onKeyDown={clickFromKeyboard}
        >
            <div role="cell"
                 className="selection-table-td pl-[25px]"
            >
                <HighlightText query={bulkTest.title}
                               keyword={searchKeyword}
                               highlightClassName="text-highlight"
                />
            </div>
            <div role="cell"
                 className="selection-table-td pl-[15px]"
            >
                <button className="group flex items-center gap-2 text-black-400 text-[14px] font-[400]"
                        onClick={() => bulkTestRepository.exportCase(agentId, bulkTest.id)}
                >
                    {bulkTest.file_name ?? "-"}
                    <DownloadIcon className="size-4 opacity-0 group-hover:opacity-100 group-focus:opacity-100" />
                </button>
            </div>
            <div role="cell"
                 className="selection-table-td pl-[17px]"
            >
                {intl.formatMessage({ id: "b0019" }, { version: bulkTest.version ?? 0 })}
            </div>
            <div role="cell"
                 className="selection-table-td pl-[15px]"
            >
                {statusLabel}
            </div>
            <div role="cell"
                 className="selection-table-td group pl-[15px]"
            >
                {isComplete ? (
                    <button className="group flex items-center gap-2 text-black-400 text-[14px] font-[400]"
                            onClick={() => bulkTestRepository.exportResult(agentId, bulkTest.id)}
                    >
                        {bulkTest.metric?.success_rate?.toFixed(2) ?? "-"}
                        <DownloadIcon className="size-4 opacity-0 group-hover:opacity-100 group-focus:opacity-100" />
                    </button>
                ) : (
                    <span className="text-black-400 text-[14px] font-[400]">
                        {bulkTest.metric?.success_rate?.toFixed(2) ?? "-"}
                    </span>
                )}
            </div>
            <div role="cell"
                 className="selection-table-td pl-[15px] tabular-nums"
            >
                {moment.utc(bulkTest.created_at).local().format("YYYY-MM-DD HH:mm")}
            </div>
        </div>
    );
};

export default BulkTestFragment;
